import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/services/authentication.service';

@Component({
	template: '',
})
export class LogoutComponent implements OnInit {
	constructor(private authenticationService: AuthenticationService, private router: Router) { }

	ngOnInit() {
		// Triggered by route /logout, then logs out and then navigates to /login
		// If a component with NavigateAwayGuard has unsaved changes, it will first fire those request and then logout
		this.authenticationService.logout().subscribe(() => {
			this.router.navigate(['login']);
		});
	}
}
